<template>
  <div
    class="wt-text-overlay-left-bar js-disable-to-reset"
    :class="{ '-no-overflow': toggleTranscript }"
  >
    <transcript-layer
      :toggle="toggleTranscript"
      :marginTop="86"
      :arrowRight="94"
    />

    <div class="wt-mask">
      <div
        v-show="showMask"
        class="wt-mask-inner first"
        @click="selectLastTextOverlay"
      />
      <div class="-title">
        <div class="wt2-text-xl">Text</div>
        <div
          v-if="thereAreTranscriptToShow"
          class="wt2-color-link wt2-text-n"
          v-text="toggleTranscriptLabel"
          @click="$_onToggleTranscript"
        />
      </div>
      <div class="wt-tinymce-toolbar-container js-tinymce-toolbar-container" />
      <div class="wt-text-overlay-actions-bar">
        <span
          class="wt-align-action distribute"
          :class="disableDistribute"
          @click="distribute"
        >
          <i class="wticon wticon-distribute_vertically" />
        </span>
        <span
          class="wt-align-action align-left"
          :class="disableAlignment"
          @click="alignLeft"
        >
          <i class="wticon wticon-Align_left" />
        </span>
        <span
          class="wt-align-action align-right"
          :class="disableAlignment"
          @click="alignRight"
        >
          <i class="wticon wticon-align_right" />
        </span>
      </div>

      <in-out-animation-picker />

      <text-styles :programmer="programmer.id" />
    </div>
  </div>
</template>

<script>
/**
 * Created by Yair on 19/03/2017.
 * Asset Editor's text overlay right bar
 * Contains tinymce toolbar & text styles component
 */
import TextStyles from 'AssetEditor/functionality/TextOverlay/TextStyles.vue';
import InOutAnimationPicker from 'AssetEditor/functionality/Animation/InOutPicker.vue';
import bus from 'v/AssetEditor/AssetEditorEventBus';
import { mapGetters, mapMutations } from 'vuex';
import TranscriptMixin from 'AssetEditor/functionality/Info/TranscriptMixin.js';

export default {
  mixins: [TranscriptMixin],

  components: {
    'text-styles': TextStyles,
    'in-out-animation-picker': InOutAnimationPicker,
  },

  computed: {
    ...mapGetters('assetEditor', [
      'tmpAGD',
      'pageTmpState',
      'story',
      'timeInAsset',
    ]),

    showMask: function () {
      return !!this.pageTmpState.mask && !this.toggleTranscript;
    },

    numTextOverlays: function () {
      const textOverlays = this.tmpAGD.textOverlays;
      const isVisible = (to) =>
        to.animationStartTime <= this.timeInAsset &&
        to.animationEndTime >= this.timeInAsset;
      if (textOverlays) {
        return textOverlays.filter(isVisible).length;
      }
      return 0;
    },

    activeTextOverlay: function () {
      return this.pageTmpState.textOverlay;
    },

    programmer: function () {
      return this.story.programmer;
    },

    disableAlignment: function () {
      return {
        disabled: this.numTextOverlays < 2,
      };
    },

    disableDistribute: function () {
      return {
        disabled: this.numTextOverlays < 3,
      };
    },
  },

  watch: {},

  methods: {
    ...mapMutations('assetEditor', [
      'setTmpPageState',
      'alignTextOverlaysLeft',
      'alignTextOverlaysRight',
      'alignTextOverlaysTop',
      'alignTextOverlaysBottom',
      'distributeTextOverlays',
    ]),

    selectLastTextOverlay: function () {
      bus.$emit('to:focusLast');
    },

    alignLeft: function () {
      if (this.numTextOverlays > 1) {
        this.alignTextOverlaysLeft(this.activeTextOverlay);
      }
    },

    alignRight: function () {
      if (this.numTextOverlays > 1) {
        this.alignTextOverlaysRight(this.activeTextOverlay);
      }
    },

    distribute: function () {
      if (this.numTextOverlays > 2) {
        this.distributeTextOverlays();
      }
    },
  },
};
</script>

<style lang="scss">
.wt-text-overlay-left-bar {
  position: relative;

  &.-no-overflow {
    overflow: hidden;
  }

  .wt-mask {
    position: relative;
    margin: 0 88px;

    .-title {
      display: flex;
      justify-content: space-between;
      align-items: baseline;
      user-select: none;
    }

    > .wt-mask-inner.first {
      content: '';
      top: 0;
      right: 0;
      left: 0;
      //height: 60px;
      bottom: 0;
      position: absolute;
      background-color: #f7fafc;
      opacity: 0.7;
      z-index: 1;
    }
    > .wt-mask-inner.second {
      content: '';
      top: 100px;
      right: 0;
      left: 0;
      bottom: 0;
      position: absolute;
      background-color: #f7fafc;
      opacity: 0.7;
      z-index: 1;
    }
  }
}
</style>
